import {useContext, useRef} from 'react';
import Button from '@cvent/carina/components/Button';
import Modal from '@cvent/carina/components/Modal';
import {globalUIContext} from '../../utils/global-ui-helpers';

type HelpAndSupportModalProps = {
  handleClose: () => void;
};

const HelpAndSupportModal = ({handleClose}: HelpAndSupportModalProps) => {
  const headerRef = useRef<HTMLHeadingElement | null>(null);
  const {isMobile} = useContext(globalUIContext);

  return (
    <Modal
      isOpen
      format={isMobile ? 'sm' : 'md'}
      onDismiss={handleClose}
      testID="help-and-support-modal"
      aria-labelledby="help-and-support-title"
    >
      <div className="flex flex-col w-[295px] sm:w-[561px] max-w-full">
        <div className="mx-6 mt-6 mb-0">
          <h1
            id="help-and-support-title"
            ref={headerRef}
            tabIndex={-1}
            className="text-[24px] font-normal leading-[var(--carina-line-height-tight)] text-[#1c2430]"
          >
            Help &amp; Support
          </h1>
        </div>
        <div className="mx-6 my-4 text-sm leading-[var(--carina-line-height-normal)] text-[#69727f]">
          <p>
            For support, please contact customer service,
            <a
              aria-label="socialtables support email link"
              href="mailto:ST.support@cvent.com"
              className="ml-1 text-[var(--carina-link-color,#006ae1)] underline"
            >
              ST.support@cvent.com
            </a>{' '}
            or call 866-318-4357. Phone support is available Monday to Friday,
            9am - 10pm ET.
          </p>
        </div>
        <div className="mx-6 my-4 flex justify-end">
          <Button
            text="Close"
            onClick={handleClose}
            type="button"
            appearance="lined"
            className={isMobile ? 'w-[247px]' : 'w-[89px]'}
          />
        </div>
      </div>
    </Modal>
  );
};

export default HelpAndSupportModal;
